var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cz2__rounded-banner",style:({ backgroundColor: _vm.bannerColor })},[_c('span',[_vm._v(" "+_vm._s(_vm.bannerCopy)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }